var map = {
	"./2AGК.png": 61190,
	"./5AGK.png": 81468,
	"./6AGK.png": 78071,
	"components/Catalog/AGK/img/allDoor/tgray/2AGК.png": 61190,
	"components/Catalog/AGK/img/allDoor/tgray/5AGK.png": 81468,
	"components/Catalog/AGK/img/allDoor/tgray/6AGK.png": 78071
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62280;